import React, { useState } from 'react';
import { Box, FormControl, FormControlLabel, Checkbox } from '@mui/material';
import { TimePicker } from '@mui/x-date-pickers';
import { TextField } from '@mui/material';
import { dateToMinutes, minutesToDate } from '../../services/Helper';

interface SchedulerCustomProps {
  startTime: number;
  endTime: number;
  setStartTime: (value: number) => void;
  setEndTime: (value: number) => void;
}

const SchedulerCustom: React.FC<SchedulerCustomProps> = ({
  startTime,
  endTime,
  setStartTime,
  setEndTime,
}) => {
  const [isAllDay, setIsAllDay] = useState(false);

  const handleAllDayChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked = event.target.checked;
    setIsAllDay(checked);

    if (checked) {
      setStartTime(540);
      setEndTime(1020);
    }
  };

  return (
      <Box sx={{ marginRight: -3, marginLeft: -3 }}>
        <FormControl fullWidth>
          <TimePicker
            label="Start Time"
            value={minutesToDate(startTime)}
            onChange={(newValue) => setStartTime(dateToMinutes(newValue))}
            renderInput={(params) => <TextField {...params} />}
            disabled={isAllDay}
          />
        </FormControl>
        <FormControl fullWidth>
          <TimePicker
            label="End Time"
            value={minutesToDate(endTime)}
            onChange={(newValue) => setEndTime(dateToMinutes(newValue))}
            minTime={minutesToDate(startTime)}
            renderInput={(params) => <TextField {...params} />}
            disabled={isAllDay}
          />
        </FormControl>

        <FormControlLabel
          control={
            <Checkbox
              checked={isAllDay}
              onChange={handleAllDayChange}
            />
          }
          label="All Day"
        />
      </Box>
  );
};

export default SchedulerCustom; 